import axios from 'axios'
import _ from 'lodash'

require('promise.prototype.finally').shim()

const ROOT_URL = '/api'
const STATUS_OK = [200, 201]
const STATUS_ERRORS = [422, 500]

export default class Request {
    /**
     * @desc Конструктор для класса
     * @param {Object} options
     **/
    constructor (options = {}) {
        this.options = options
    }

    /**
     * @desc Проверяет как мы должны обрабатывать ответ сервера (промисы или await/async)
     * @return {Boolean}
     **/
    usePromise () {
        return this.options
            ? this.options.promise
            : true
    }

    /**
     * @desc Check the response handler
     * @return {Object}
     **/
    responseHandler (response = {}) {
        response = response || {}

        /**
         * @desc check if response is succeed
         * @return {Boolean}
         **/
        response.isSuccess = function () {
            return _.some(STATUS_OK, code => {
                return this.status === code
            })
        }.bind(response)

        /**
         * @desc check if errors
         * @return {Boolean}
         **/
        response.isFailed = function () {
            return _.some(STATUS_ERRORS, code => {
                return this.status === code
            })
        }.bind(response)

        /**
         * @desc return the data
         * @return {Object}
         **/
        response.getData = function () {
            return this.data ? this.data.data : {}
        }.bind(response)

        /**
         * @desc return the message
         * @return {Object}
         **/
        response.getMessage = function () {
            return this.data ? this.data.message : {}
        }.bind(response)

        /**
         * @desc return the errors
         * @return {Object}
         **/

        response.getErrors = function () {
            return this.data ? this.data.errors : {}
        }.bind(response)

        return Promise.resolve(Object.assign({},
            response
        ))
    }

    /**
     * @desc Обработчик для асинхронногой вызова
     * @param {Object} result
     * @return {Object}
     **/
    asyncHandler (result = {}) {
        result = result || {}

        // /**
        //  * @desc Получить объект с данными
        //  * @return {Object}
        //  **/
        // result.getData = function () {
        //     return this.data || {}
        // }.bind(result)

        // return Object.assign({}, result)
        return result
    }

    /**
     * @desc handle the GET requests
     * @param {String} callId - identifier from the SYSTEM_CALLS
     * @param {String} params - the string which are going to be connected to the URL string
     * @param {Object} config - axios configuration object (https://github.com/mzabriskie/axios#request-config)
     *
     * @return {Promise|Object}
     **/
    get (callId, params = '', config = {}) {
        const call = axios.get(Request.url(callId, params), config)

        if (this.usePromise() === false) {
            return this.asyncHandler(call)
        } else {
            return call.then((response) => {
                return this.responseHandler(response)
            })
        }
    }

    /**
     * @desc handle the POST requests
     * @param {String} callId - identifier from the SYSTEM_CALLS
     * @param {Object} data
     * @param {String} params - the string which are going to be connected to the URL string
     * @param {Object} config - axios configuration object (https://github.com/mzabriskie/axios#request-config)
     *
     * @return {Promise}
     **/
    post (callId, data = {}, params = '', config = {}) {
        let result = Request.url(callId, params)
        if (!params || params === '') {
            result = Request.url(callId, params).slice(0, -1)
        }
        return axios.post(result, data, config)
            .then((response) => {
                return this.responseHandler(response)
            })
    }

    /**
     * @desc handle the DELETE requests
     * @param {String} callId - identifier from the SYSTEM_CALLS
     * @param {String} params - the string which are going to be connected to the URL string
     * @param {Object} config - axios configuration object (https://github.com/mzabriskie/axios#request-config)
     *
     * @return {Promise}
     **/
    delete (callId, params = '', config = {}) {
        return axios.delete(Request.url(callId, params), config)
            .then((response) => {
                return this.responseHandler(response)
            })
    }

    /**
     * @desc handle the PUT requests
     * @param {String} callId - identifier from the SYSTEM_CALLS
     * @param {Object} data
     * @param {String} params - the string which are going to be connected to the URL string
     * @param {Object} config - axios configuration object (https://github.com/mzabriskie/axios#request-config)
     *
     * @return {Promise}
     **/
    put (callId, data = {}, params = '', config = {}) {
        return axios.put(Request.url(callId, params), data, config)
            .then((response) => {
                return this.responseHandler(response)
            })
    }

    /**
     * @desc Builds the system URL
     * @param {String} callId
     * @param {String} params
     * @return {String}
     **/
    static url (callId, params) {
        return ROOT_URL + callId + (params || '');
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/Requests.js